import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setGetShift } from '../../store/thunk/setGetShift';
import TemplatePage from '../../../components/templatePage';
import CashiersItem from '../../components/cashiersItem';
import { setGetShiftAction } from '../../store/action';
import moment from 'moment';

const ShiftList = () => {
    const utc = moment.utc().valueOf();
    const dispatch = useDispatch();
    const [currentDate, setCurrentDate] = React.useState(utc)
    const [startDate, setStartData] = React.useState(0);
    const [search, setSearch] = React.useState('');

    React.useEffect(() => {
        dispatch(setGetShift({
            page: 1,
            rowsPerPage: 20,
            search,
            date_from: startDate,
            date_to: currentDate
        }));
    }, [search, startDate, currentDate])

    const list = useSelector(state => state.cashiersMobile.shift);

    return (
        <TemplatePage
            title="Отчет по сменам"
            datePicker
            changeDate={({date_from, date_to}) => {
                dispatch(setGetShiftAction({
                    data: [],
                    countPage: 1
                })); 
                setCurrentDate(date_to);
                setStartData(date_from);
            }}
            search={true}
            searchValue={search}
            onChangeSearch={(v) => {
                dispatch(setGetShiftAction({
                    data: [],
                    countPage: 1
                })); 
                setSearch(v)
            }}
        >
            {
                list.data.map((item) => <CashiersItem item={item}/>)
            }
            {
                !list.data.length && <span style={{width: '100%', color: '#fff', display: 'flex', justifyContent: 'center', padding: 20}}>Информация отсутствует</span>
            }
        </TemplatePage>
            
    )
}

export default ShiftList;